import { Theme } from '@emotion/react'
import { PaletteMode } from '@mui/material'
import { DisplayEnum } from 'pages/WorkspacePage/Configurations/Device/DeviceSettings.constants'
import { selectDisplayMode } from 'pages/WorkspacePage/Configurations/User/Settings.slice'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

export enum PaletteModeEnum {
  LIGHT = 'light',
  DARK = 'dark',
}

export function usePaletteMode(): PaletteMode {
  const [systemMode, setSystemMode] = useState(getSystemColorScheme(window.matchMedia('(prefers-color-scheme: dark)')))
  const displayMode = useSelector(selectDisplayMode)

  useEffect(() => {
    const query = window.matchMedia('(prefers-color-scheme: dark)')
    const handler = (evt: { matches: boolean }) => {
      setSystemMode(getSystemColorScheme(evt))
    }

    query.addEventListener('change', handler)

    return () => {
      query.removeEventListener('change', handler)
    }
  }, [])

  function getSystemColorScheme({ matches }: { matches: boolean }) {
    return matches ? PaletteModeEnum.DARK : PaletteModeEnum.LIGHT
  }

  return displayMode === DisplayEnum.DEFAULT
    ? systemMode
    : displayMode === DisplayEnum.DARK
    ? PaletteModeEnum.DARK
    : PaletteModeEnum.LIGHT
}

export function isDarkMode(theme: Theme) {
  return theme.palette.mode === PaletteModeEnum.DARK
}
